import React, { Component } from 'react';

// reusable
import { EntityLogo } from '/src/components/Reusable/EntityLogo';
import SimpleListSection from '/src/components/SingleSICE/Reusable/SimpleListSection';
import SocialTab from '/src/components/SingleSICE/Reusable/SocialTab';
import CompanyContactButton from '/src/components/SingleSICE/Reusable/CompanyContactButton';

// helpers
import { getItemWebUrl } from "/src/lib/helpers";
import * as sliderHelpers from './sliderHelpers';

// constants
import { HUBSPOT_FORM_SOURCE, ENTITY_TYPE } from '/src/lib/constants';
import PeopleSection from '/src/components/SingleSICE/Reusable/Team/PeopleSection';

// set default values in case the calculation fails
const INITIAL = {
    SLIDER_WIDTH: 400,
    SLIDER_OFFSET: -900,
}
const MAX_SLIDER_WIDTH = 760;

// max display value for team + inv
const MAX_TO_DISPLAY = 4;



class DirectorySlidingContent extends Component {

    constructor(props) {
        super(props);
        const entity = props.entityType.toLowerCase();
        this.state = {
            sliderWidth: INITIAL.SLIDER_WIDTH,
            sliderOffset: INITIAL.SLIDER_OFFSET,
            current_index: null,
            // data
            selectedEntity: null,
            entityType: entity,
        }
        this.directoryType = entity;
    }

    // it's handled this way as the trigger link is saved in a component that's sent to DirTable.js
    // so it's not straightforward to use onClick/setState

    // an element of this slider's table: inside tableContainerName when scopeTableToContainer is set (several tables on the page), else the nth on the page
    getTableElement = (className, index) => {
        const { tableContainerName, scopeTableToContainer } = this.props;
        return scopeTableToContainer && tableContainerName
            ? document.querySelector(`.${tableContainerName} .${className}`)
            : document.getElementsByClassName(className)[index];
    }

    // we are listening to directory-table so clicks on new rows can be captured as well
    watchSliderTrigger = () => {
        const { isFundingView, isExitsView } = this.props;
        const index = isExitsView ? 2 : (isFundingView ? 1 : 0);
        const table = this.getTableElement("directory-table", index);

        if (table) {
            table.addEventListener('click', this.triggerSlider, false);
        }

        // remove hover component on slider open
        const popovers = document?.querySelectorAll(".popover");
        if (popovers && popovers.length > 0) {
            popovers.forEach(popover => popover.remove());
        }
    }

    triggerSlider = (e) => {
        const targetData = e.target.dataset; // get data-props
        const { directoryType } = this;
        const { entityData, user } = this.props;   // entity data of rows visible in the directory

        if (targetData.action === "expand-slider" && Array.isArray(entityData)) {
            entityData.map((entity, i) => {
                // a row index (data-rowindex) picks the clicked row when the same entity is on several rows
                const isClickedRow = targetData.rowindex === undefined || Number(targetData.rowindex) === i;
                if (entity && entity.id == targetData.entityid && isClickedRow) {

                    let type = directoryType;
                    if (type === 'investor' || type === 'private equity') {
                        type = targetData.ecosystemtype;
                    } else if (type === 'company') {
                        type = entity.entity_type ? entity.entity_type.toLowerCase() : 'startup';
                    }

                    const companyInfo = sliderHelpers.getCompanyInfo(type, entity);

                    this.setState({
                        selectedEntity: entity,
                        current_index: i,
                        companyInfo,
                        entityType: type
                    }, () => {
                        this.callAdditionalFields(entity.id);
                        sliderHelpers.expandSlider(user);
                    });

                }
            });
        }
    }

    /* necessary to do it this way so we can get the data passed with the trigger element */
    sliderButtons = (type) => {
        const { current_index } = this.state;
        const { tableContainerName } = this.props;

        if (typeof window.jQuery !== 'undefined') {
            const tableContainerQuerySelector = tableContainerName ? `.${tableContainerName}` : '';
            const entities = $(`${tableContainerQuerySelector} [data-action="expand-slider"]`);

            if (type === "prev") {
                entities[current_index - 1]?.click();
            } else {
                entities[current_index + 1]?.click();
            }

            // reset company contact
            if (typeof window.jQuery !== 'undefined' && $?.fn?.popover) {
                $('#companyEmailPopover').popover('hide');
            }
        }
    }

    callAdditionalFields = (entityId) => {
        const { selectedEntity, entityType } = this.state;
        const { directoryType } = this;
        sliderHelpers.getDataForSlider(entityId, entityType).then(
            response => {
                let tempData = { ...selectedEntity, ...response };
                let companyInfo = null;

                if (directoryType === 'private equity') {
                    let eType = tempData.entity_type ? tempData.entity_type : tempData.type;
                    let type = (eType === ENTITY_TYPE.startup) ? 'startup' : 'investor';
                    companyInfo = sliderHelpers.getCompanyInfo(type, tempData, directoryType);
                } else if (directoryType === 'company') {
                    companyInfo = sliderHelpers.getCompanyInfo(entityType, tempData);
                } else {
                    companyInfo = sliderHelpers.getCompanyInfo(directoryType, tempData);
                }

                this.setState({
                    selectedEntity: tempData,
                    companyInfo
                });
            }
        )
    }

    componentDidMount = () => {
        this.watchSliderTrigger();
    }

    componentDidUpdate = () => {
        const { sliderWidth } = this.state;
        if (sliderWidth === INITIAL.SLIDER_WIDTH) {
            this.calculateWidth();
        }
        this.watchSliderTrigger();
    }

    componentWillUnmount = () => {
        const dirTable = this.props.scopeTableToContainer ? this.getTableElement("directory-table") : document.querySelector(".directory-table");
        if (dirTable) {
            dirTable.removeEventListener("click", this.triggerSlider);
        }
    }

    // calculate slider width
    calculateWidth = () => {

        // check directory fully loaded
        const { isFundingView, isExitsView } = this.props;
        const tableIndex = isExitsView ? 2 : (isFundingView ? 1 : 0);
        const table = this.getTableElement("table-responsive", tableIndex);
        const tableLoaded = (table && table.clientWidth > 0);

        if (!tableLoaded) {
            return;
        }

        const nameCol = this.props.scopeTableToContainer ? table.querySelector('[data-rowtype="name"]') : document.querySelector('[data-rowtype="name"]');
        const dirElement = document.getElementsByClassName("directory")[0];

        // mobile, small tablet (full width)
        if (window.innerWidth <= 900) {
            this.setState({
                sliderWidth: '100%',
                sliderOffset: '-100%'
            })
        }
        // desktop, large tablet (lines up with the end of the 'name' column)
        else if (table && nameCol && dirElement) {
            const tableWidth = table.clientWidth;
            const nameColWidth = nameCol.clientWidth;
            const pagePadding = window.getComputedStyle(dirElement, null).getPropertyValue('padding-left');

            let sliderWidth = tableWidth - nameColWidth + parseFloat(pagePadding);
            if (sliderWidth > MAX_SLIDER_WIDTH) {
                sliderWidth = MAX_SLIDER_WIDTH;
            }
            this.setState({ sliderWidth, sliderOffset: -sliderWidth })
        }
    }

    login = () => {
        const headerLogin = document.getElementById('headerLogin');
        if (headerLogin) {
            headerLogin.click();
        }
    }

    render() {

        /* note:
            - fields already available in the directory will be shared with this component
            - additional fields will be called on componentDidMount
        */

        // constants
        const { sliderWidth, sliderOffset } = this.state;
        const sliderStyle = {
            width: sliderWidth,
            right: sliderOffset,
        }

        // from state and props
        const { selectedEntity, current_index, companyInfo, entityType } = this.state;
        const { directoryType } = this;
        const { user, entityData } = this.props;
        const data = selectedEntity; // for readability

        const page_source = HUBSPOT_FORM_SOURCE.dir_locked_contacts;

        let profile_url = "", dataType = "";
        if (data) {
            const strEntityType = entityType + "s";
            profile_url = "/" + getItemWebUrl(strEntityType, data.id, data.code);

            // Show Investors (for startups) or Startup Relations (for ICE) on slider
            const eType = data.entity_type ? data.entity_type : data.type;
            const isStartupEntity = directoryType === 'startup' ||
                (directoryType === 'private equity' && eType === ENTITY_TYPE.startup) ||
                (directoryType === 'company' && entityType === 'startup');
            dataType = isStartupEntity ? 'investor' : 'startup-relation';
        }

        const entityOverviewInfo = () => {
            return companyInfo && companyInfo.overview.length > 0 ? companyInfo.overview : [];
        }

        const entityInfoData = () => {
            return companyInfo && companyInfo.data.length > 0 ? companyInfo.data : [];
        }

        return (
            <>
                <div className="slider-container sidebar" data-expanded="false" style={sliderStyle}>

                    {/* conditional rendering of 'data' must be inside .slider-container, not outside
                    otherwise it causes issues with the slider opening animation */}

                    {data && <>

                        <div className="slider-header-section">

                            <div className="slider-btn-box">
                                {/* next and prev btns */}
                                {(current_index > 0) ?
                                    <a onClick={() => this.sliderButtons("prev")}>
                                        <i className="fas fa-chevron-circle-left"></i>
                                    </a>
                                    :
                                    // disabled btn
                                    <i className="fas fa-chevron-circle-left disabled"></i>
                                }
                                {(current_index < (entityData.length - 1)) ?
                                    <a onClick={() => this.sliderButtons("next")}>
                                        <i className="fas fa-chevron-circle-right"></i>
                                    </a>
                                    :
                                    // disabled btn
                                    <i className="fas fa-chevron-circle-right disabled"></i>
                                }

                                <a onClick={() => sliderHelpers.closeSlider(user)}>
                                    <i className="fas fa-times-circle"></i>
                                </a>
                            </div>

                            <div className="row">

                                <div className="col-2">
                                    <EntityLogo data={data} entityType={entityType} size={"responsive"} />
                                </div>

                                <div className="col-10">

                                    <a className="slider-header" href={profile_url} target="_blank" rel="noopener noreferrer">
                                        {data.name}
                                    </a>

                                    <div className="slider-text">

                                        {entityOverviewInfo().map((data, i) =>
                                            <div key={`${data.id}_${i}`}>
                                                <span>{data.field}: </span>
                                                {data.value}
                                            </div>)
                                        }

                                        <CompanyContactButton
                                            user={user}
                                            id={data.id}
                                            entityType={entityType}
                                            setState={this.props.setState}
                                            page={page_source}
                                        />

                                    </div>

                                    <SocialTab object={data} size="small" />

                                </div>

                            </div>
                        </div>

                        <hr />

                        <div className="slider-scrollable">

                            <h3>Company Information</h3>
                            <div className="row">
                                <div className="col slider-text slider-detail-text">
                                    {entityInfoData().map((data, i) =>
                                        <div key={`${data.id}_${i}`}>
                                            <div className="circle-icon"><i className={data.icon}></i></div>
                                            <div>
                                                <span>{data.field}: </span>
                                                {data.value}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                            <div className="content-block">
                                <div className="right-side">
                                    <PeopleSection
                                        entityType={entityType}
                                        entityName={data.name}
                                        entityId={data.id}
                                        isDirSlider={true}
                                        limit={MAX_TO_DISPLAY}
                                        user={user}
                                        setState={this.props.setState}
                                        page={page_source}
                                    />
                                </div>
                            </div>

                            <div className="content-block">
                                <div className="right-side">
                                    <SimpleListSection
                                        dataType={dataType}
                                        entityId={data.id}
                                        entityType={entityType}
                                        isDirSlider={true}
                                        limit={MAX_TO_DISPLAY}
                                        user={user}
                                        setState={(s, c) => { this.setState(s, c) }}
                                    />
                                </div>
                            </div>

                            {!user.is_loggedin &&
                                <>
                                    <hr />
                                    <h3>Login for More</h3>
                                    <p>
                                        <a className="red" onClick={() => this.login()}>
                                            Login
                                        </a> to view this {entityType}'s employee team and{' '}
                                        {entityType === 'startup' ? 'investor information' : 'invested startups'}
                                    </p>
                                </>
                            }

                            {<div className="slider-button">
                                <a className="btn btn-main" href={profile_url} target="_blank" rel="noopener noreferrer">
                                    View Full Profile
                                </a>
                            </div>}

                        </div>
                    </>}
                </div>

                {/* slider overlay, modified from original bootstrap version to add hide fade as well */}
                <div
                    className="slider-backdrop"
                    id="slider-overlay"
                    onClick={() => sliderHelpers.closeSlider(user)}
                ></div>
            </>
        )
    }

}

export default DirectorySlidingContent;
